import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link, useHistory, useParams } from "react-router-dom";
import useSocket from "src/_common/hooks/useSocket";
import {
  useAppUserDetailsSelector,
  useAppUserTokenSelector,
} from "src/_common/hooks/selectors/userSelector";
import {
  useAppEventStatusMessageSelector,
  useAppGameDetailsSelector,
  useAppIrStatusMessageSelector,
  useAppSiteHeaderSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  URLS,
  STORAGE,
  SELECTED_EVENT_STORAGE,
  INSIDERODEO_EVENT_STORAGE,
  CRYPTO_SECRET_KEY,
  APPLICATION_GLOBAL_SLUG,
} from "src/_config";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { SOCKET_CHANNEL, SOCKET_URL, RODEO_PAGE_NAME,SOCKET_TRANSPORTS } from "src/_config";
import GuestSaveVoteModal from "../events/modal/guestSaveVoteModal";
import StatusModal from "../events/modal/statusModal";
import CouponModal from "../events/modal/couponModal";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import UpdateDisplayNameModal from "../events/modal/updateDisplayNameModal";
import VideoModal from "../events/modal/videoModal";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

interface SideBarProps {
  page: string;
}

function Sidebar({ page }: SideBarProps) {
  const siteHeader = useAppSiteHeaderSelector();
  const history = useHistory();
  const userDetails = useAppUserDetailsSelector() as {
    id?: number;
    first_name?: string;
    last_name?: string;
    full_name?: string;
    display_name?: string;
  } | null;
  const statusMessageSelector = useAppEventStatusMessageSelector() as Array<{ status_text?: string; rodeo_event_id?: number }> | null;
  const irStatusMessageSelector = useAppIrStatusMessageSelector() as string | null;
  const userAction = useAppUserAction();
  const eventAction = useAppEventAction();
  const userApi = useUserApi();
  // const guestUserId = useAppGuestUserIdSelector()
  const [showGuestSaveVoteModal, setShowGuestSaveVoteModal] = useState<boolean>(false);

  const { eventId } = useParams<{ eventId?: string }>();
  // const e_id: number = parseInt(cryptr.decrypt(eventId));

  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);
  const [appRedirectData, setAppRedirectData] = useState<Record<string, unknown> & { message?: string } | null>(null);
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [showCouponModal, setShowCouponModal] = useState<boolean>(false);
  const [couponData] = useState<{ image?: string; type?: number } | null>(null);
  const userToken = useAppUserTokenSelector();
  const autoLogin = localStorage.getItem("autoLogin");

  // const [showHeaderMenu, setShowHeaderMenu] = useState<boolean>(true)
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const eventApi = useEventApi();
  const gameDetails = useAppGameDetailsSelector() as {
    promotional_video_image?: { file_mime?: string; original?: string };
    logo?: { original?: string };
  } | null;
  const [showDisplayNameModal, setShowDisplayNameModal] = useState<boolean>(false);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [url, setUrl] = useState<string>("");
  const [promoType, setPromoType] = useState<string>("");

  const getGameDetails = () => {
    const params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (_message: string, resp: unknown) => {
        if (resp && typeof resp === "object") {
          const respData = resp as { is_show_landing_page?: number; redirect_automatically?: number };
          // console.log({resp})
          // if(resp?.is_show_landing_page) {
          //   history.push(URLS.LANDING)
          // }

          if (respData.is_show_landing_page == 1 && respData.redirect_automatically != 1) {
            localStorage.removeItem("redirectedFromLanding");
            history.push(URLS.HOME);
          }
          if (respData.is_show_landing_page == 1 && respData.redirect_automatically == 1) {
            const redirectedFromLanding = localStorage.getItem("redirectedFromLanding");
            if (!redirectedFromLanding) {
              history.push(URLS.HOME);
            }
          }
          if (respData.is_show_landing_page == 0) {
            localStorage.removeItem("redirectedFromLanding");
          }
        }
      },
      (_message: string) => {}
    );
  };

  const toogleSideBarOnOff = (status: boolean) => {
    const sidebarCollapseElement = document.getElementById("sidebarCollapse");
    const sidebarElement = document.getElementById("sidebar");
    const overlayElement = document.getElementById("overlay");
    if (status) {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.add("active");
        overlayElement?.classList.add("active");
      }
    } else {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.remove("active");
        overlayElement?.classList.remove("active");
      }
    }
  };

  // const toogleProfileMenuBarOnOff = () => {
  //   var navbarCollapseElement = document.getElementById("navbarCollapse");
  //   setShowHeaderMenu(!showHeaderMenu)
  //   if (showHeaderMenu) {
  //     if (navbarCollapseElement) {
  //       navbarCollapseElement.classList.add("show")
  //     }
  //   } else {
  //     if (navbarCollapseElement) {
  //       navbarCollapseElement.classList.remove("show")
  //     }
  //   }
  // }

  const logOut = (_e: React.MouseEvent) => {
    userApi.callLogout(
      (_message: string) => {
        // if (resp) {
        toogleSideBarOnOff(false);
        userAction.logout();
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(SELECTED_EVENT_STORAGE);
        localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);
        history.push(URLS.HOME);
        // } else {
        //   toast.error(message)
        // }
      },
      (_message: string) => {
        userAction.logout();
        // toast.error(message)
      }
    );
  };


  const closeGuestSaveVoteModal = () => {
    if (showGuestSaveVoteModal) setShowGuestSaveVoteModal(false);

    eventAction.resetPickIds();
    userAction.resetGuestUserId();
    localStorage.removeItem("guestUserId");
    history.push(URLS.HOME);
  };

  const onSuccessGuestSaveVoteModal = (status: boolean) => {
    if (status) {
      // console.log("APIcall")
      // saveVote()
      history.push(URLS.LOGIN);
    }
  };

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  const onCouponModalClose = () => {
    setShowCouponModal(false);
  };

  const closeVideoModal = () => {
    localStorage.setItem("loginPromoVidSeen", "1");
    setTimeout(() => setShowVideoModal(false), 1000);
  };

  const onStatusModalSuccess = () => {
    if (appRedirectData && typeof appRedirectData === "object" && "game_info" in appRedirectData) {
      setShowStatusModal(false);
      const link = (appRedirectData as { game_info: { pwa_link?: string }; rodeo_event_id?: number }).game_info.pwa_link;
      if (link) {
        // if (userDetails && userToken) {
        const appData = appRedirectData as { game_info: { pwa_link?: string }; rodeo_event_id?: number };
        window.location.href =
          link +
          (appData?.rodeo_event_id
            ? `#token=${cryptr.encrypt(String(appData.rodeo_event_id))}&userToken=${userToken || ''}`
            : "");
        // }
      }
    }
  };

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: Record<string, unknown> & { status?: number; rodeo_event_id?: number }) => {
      let e_id = -1;
      if (eventId) {
        e_id = parseInt(cryptr.decrypt(eventId));
      }
      const guestUserId = localStorage.getItem("guestUserId");
      console.log({ e_id, changeEventStatus, guestUserId });
      if (
        changeEventStatus &&
        changeEventStatus.status == 2 &&
        changeEventStatus.rodeo_event_id == e_id &&
        guestUserId
      ) {
        // console.log(changeEventStatus)
        setShowGuestSaveVoteModal(true);
      }
    });

    socket.on(SOCKET_CHANNEL.APP_REDIRECT, (data: Record<string, unknown> & { game_info?: { slug?: string } }) => {
      if (data.game_info?.slug != APPLICATION_GLOBAL_SLUG) {
        // console.log({data})
        setShowStatusModal(true);
        setAppRedirectData(data);
      }
    });

    // socket.on(SOCKET_CHANNEL.COUPON, (data: any) => {
    //   // console.log({data})
    //   setCouponData(data);
    //   setShowCouponModal(true);
    // });

    socket.on(SOCKET_CHANNEL.IR_STATUS_MSG, (changeEventStatus: Record<string, unknown> & { site?: string }) => {
      console.log("irStatus", changeEventStatus);
      if (changeEventStatus?.site == APPLICATION_GLOBAL_SLUG) {
        eventAction.getIrStatusMessage(changeEventStatus);
      }
    });

    //Status Message Change Socket
    socket.on(SOCKET_CHANNEL.STATUS_MESSAGE, (statusMessage: Record<string, unknown> & { rodeo_event_id?: number }) => {
      // console.log({statusMessage})
      if (eventId) {
        const e_id = parseInt(cryptr.decrypt(eventId));
        if (statusMessage.rodeo_event_id == e_id) {
          eventAction.setStatusMsg([statusMessage]);
        }
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    // console.log({siteHeader,page})
    const elem = document.getElementsByClassName("main-container")[0] as HTMLElement | undefined;
    if (elem) {
      if (siteHeader != 1 || page == RODEO_PAGE_NAME.EVENT_LIST) {
        elem.style.paddingTop = "15px";
      } else {
        elem.style.paddingTop = "80px";
      }
    }
    const parshedHash = localStorage.getItem("parshedHash");
    if (parshedHash == "1") {
      userApi.callCreateUpdateUserGame(
        {
          game_slug: APPLICATION_GLOBAL_SLUG,
        },
        (_message: string, resp: unknown) => {
          console.log({ resp });
          localStorage.removeItem("parshedHash");
        },
        (_message: string) => {}
      );
    }
  }, [siteHeader, page]);

  useEffect(() => {
    getGameDetails();
  }, []);

  const onPageChange = () => {
    if (userDetails && !userDetails.display_name) {
      // console.log({userDetails})
      setShowDisplayNameModal(true);
    }
  };

  useEffect(() => {
    onPageChange();
  }, []);

  useEffect(() => {
    if (userToken) {
      userApi.callCheckValidToken(
        (_message: string, resp: unknown) => {
          // console.log(1,{resp})
          if (!resp) {
            // console.log(2,{resp})
            userAction.logout();
          }
        },
        (_message: string) => {
          // console.log(3,{resp})
          userAction.logout();
        }
      );
    }
  }, [page]);

  useEffect(() => {
    const x = localStorage.getItem("loginPromoVidSeen");
    if (page == RODEO_PAGE_NAME.LOGIN && gameDetails?.promotional_video_image && x != "1") {
      const vid = gameDetails?.promotional_video_image as { file_mime?: string; original?: string } | undefined;
      const type = vid?.file_mime?.substring(0, vid?.file_mime?.indexOf("/"));
      if (type) {
        setPromoType(type);
      }
      if (vid?.original) {
        setUrl(vid.original);
      }
      if (type == "video" || type == "image") {
        setShowVideoModal(true);
      }
    }
  }, [page, gameDetails]);

  const gotoHome = () => {
    history.push(URLS.HOME);
  };

  // const refreshCacheAndReload = () => {
  //   if (caches) {
  //     // Service worker cache should be cleared with caches.delete()
  //     caches.keys().then((names) => {
  //       for (const name of names) {
  //         caches.delete(name);
  //       }
  //     });
  //   }
  //   // delete browser cache and hard reload
  //   window.location.reload();
  // }

  // useEffect(()=>{
  //   let ver = localStorage.getItem('buildVersion')
  //   if(ver) {
  //     if(ver!=APPLICATION_VERSION) {
  //       localStorage.setItem('buildVersion',APPLICATION_VERSION)
  //       refreshCacheAndReload()
  //     }
  //   } else {
  //     localStorage.setItem('buildVersion',APPLICATION_VERSION)
  //   }
  // },[])

  useEffect(() => {
    localStorage.removeItem("autoLogin");
  }, []);

  return (
    <>
      {url && showVideoModal && promoType && (
        <VideoModal onClose={closeVideoModal} url={url} shouldShow={showVideoModal} type={promoType} />
      )}
      {/* <section className={"top-nav "+([RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && siteHeader==1?"":"d-none")}> */}
      <section
        className={
          "top-nav " +
          (((page == RODEO_PAGE_NAME.CMS ||
            page == RODEO_PAGE_NAME.MY_ACCOUNT ||
            page == RODEO_PAGE_NAME.TEAM_IMAGE ||
            eventId) &&
            siteHeader == 1) ||
          page == RODEO_PAGE_NAME.MY_TEAM
            ? ""
            : "d-none")
        }
      >
        {/*LEFT MENU*/}
        {/*Navbar*/}
        <nav
          id="sidebar"
          className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
          style={{ overflow: "visible" }}
        >
          <div id="dismiss" onClick={() => toogleSideBarOnOff(false)}>
            <i className="fa fa-arrow-left" />
          </div>
          <div className="sidebar-header">
            {gameDetails?.logo?.original && (
              <img src={gameDetails?.logo?.original} alt="Scavenger Hunt" onClick={gotoHome} />
            )}{" "}
            Scavenger Hunt
          </div>
          {userDetails && (
            <div className="head-user">
              {/* Welcome, {userDetails && userDetails.full_name && userDetails.full_name !== " " ? userDetails.full_name : ' User'} */}
              Welcome,{" "}
              {userDetails && userDetails.first_name && userDetails.last_name
                ? userDetails.first_name + " " + userDetails.last_name
                : " User"}
            </div>
          )}

          {/* <ul className="list-unstyled components">
            {
              !isInsideRodeoTokenExists ?
                <li>
                  <Link to={URLS.HOME}>Rodeo Events</Link>
                </li> : null
            }
            {
              userDetails ?
              <li>
                <Link to={URLS.USER.PROFILE}>My Profile</Link>
              </li>
              :
              <li>
                <Link to={URLS.LOGIN}>Login</Link>
              </li>
            }

            <li>
              <Link to={URLS.CMS.ABOUT_US}>About Us</Link>
            </li>
            <li>
              <Link to={URLS.CMS.LEGAL}>Legal</Link>
            </li>
            {
              userDetails && !autoLogin &&
              <li>
                <Link to="#" onClick={(e) => logOut(e)}>Logout</Link>
              </li>
            }

          </ul> */}
        </nav>
        <nav className="navbar navbar-light">
          <div className="container-fluid">
            {/* <button type="button" id="sidebarCollapse" className="btn-none">
              <span className="open-nav" onClick={() => toogleSideBarOnOff(true)}><i className="fa fa-bars"></i></span>
            </button> */}
            <div className="left-logo">
              {gameDetails?.logo?.original && (
                <img src={gameDetails?.logo?.original} alt="Scavenger Hunt" onClick={gotoHome} />
              )}
            </div>
            {
              // [RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && statusMessageSelector && statusMessageSelector[0]?.status_text ?
              statusMessageSelector && statusMessageSelector[0]?.status_text && eventId ? (
                <div className="status-bar-wrap">
                  <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                    {
                      // statusMessageSelector && statusMessageSelector.length ?
                      // statusMessageSelector.map((status: any) => status.status_text).join(',')
                      String(statusMessageSelector[0]?.status_text ?? "")
                    }
                  </Marquee>
                </div>
              ) : irStatusMessageSelector ? (
                <div className="status-bar-wrap">
                  <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                    {String(irStatusMessageSelector ?? "")}
                  </Marquee>
                </div>
              ) : null
            }
            {/* {
              userDetails &&
              <button
                className="navbar-toggler btn-none d-inline-block ml-auto user-image"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
                // onClick={toogleProfileMenuBarOnOff}
                onClick={goToMyAccount}
              >
                <img src="/images/user.svg" alt="User" />
              </button>
            } */}
          </div>
        </nav>
        <div className="overlay" id="overlay" onClick={() => toogleSideBarOnOff(false)} />

        {/* IOS Scrren Add to home scrren option popup */}
        {/* {
          detectDevice() && isShowIosPopup ?
            <>
              < div className="bottom_fixedsec">
                <div className="mid-sec">
                  <h2>To add this Instant app to the home screen: tap <span className="share-x-icon" /> and then Add to Home Screen.</h2>
                </div>
                <div className="icon_div_right">
                  <a href="#" onClick={(e) => closeIosPopup(e)}>
                    <svg className="svg-inline--fa fa-times-circle fa-w-16" aria-hidden="true" data-prefix="fa" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg>
                      <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
                    </svg>
                  </a>
                </div>
              </div>
            </> : null
        } */}
      </section>

      {!autoLogin && (
        <>
          {/* <div className={"floating-btns "+(showMenu ? "floating-btns-show" : "")}> */}
          {/* <div className={"floating-btns "+([RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && siteHeader==1?"":"d-none ")+(showMenu ? "floating-btns-show" : "")}> */}
          <div
            className={
              "floating-btns " + (eventId && siteHeader == 1 ? "" : "d-none ") + (showMenu ? "floating-btns-show" : "")
            }
          >
            {!isInsideRodeoTokenExists ? <Link to={URLS.HOME}>Rodeo Events</Link> : null}

            {userDetails ? <Link to={URLS.USER.PROFILE}>My Profile</Link> : <Link to={URLS.LOGIN}>Login</Link>}

            {/* { userDetails && eventId ? <Link to={`/winning-ticket/${eventId}`}>My Correct Picks</Link> : null }
              
              { userDetails && eventId ? <Link to={`/my-team/${eventId}`}>My Team</Link> : null } */}

            <Link to={"/cms/contact-us"}>Contact Us</Link>

            <Link to={"/cms/about-us"}>About Us</Link>

            <Link to={"/cms/prize-winner"}>Prizes</Link>

            <Link to={"/cms/map"}>Map</Link>

            <Link to={"/cms/how-to-play"}>How to Play</Link>

            <Link to={"/cms/legal"}>Legal</Link>

            {userDetails && !autoLogin && (
              <a style={{ color: "white", cursor: "pointer" }} onClick={(e) => logOut(e)}>
                Logout
              </a>
            )}
          </div>

          {/* <div className={"float-bar-icon "+([RODEO_PAGE_NAME.EVENT_GAME_LIST, RODEO_PAGE_NAME.PERFORMANCE_LIST, RODEO_PAGE_NAME.EVENT_GAME_DETAILS, RODEO_PAGE_NAME.RIDER_LIST].includes(page) && siteHeader==1?"":"d-none")} onClick={()=>setShowMenu(!showMenu)}> */}
          <div
            className={"float-bar-icon " + (eventId && siteHeader == 1 ? "" : "d-none")}
            onClick={() => setShowMenu(!showMenu)}
          >
            <i className="fa fa-list" aria-hidden="true" />
          </div>
        </>
      )}

      {showGuestSaveVoteModal && (
        <GuestSaveVoteModal
          onClose={closeGuestSaveVoteModal}
          onSuccess={onSuccessGuestSaveVoteModal}
          shouldShow={showGuestSaveVoteModal}
        />
      )}
      {showStatusModal && appRedirectData && (
        <StatusModal
          shouldShow={showStatusModal}
          onClose={onStatusModalClose}
          onSuccess={onStatusModalSuccess}
          message={(appRedirectData as { message?: string } | null)?.message ?? ""}
          type={2}
        />
      )}
      {showDisplayNameModal && (
        <UpdateDisplayNameModal onClose={() => setShowDisplayNameModal(false)} shouldShow={showDisplayNameModal} />
      )}
      {showCouponModal &&
        couponData &&
        couponData.image &&
        (couponData.type == 1 || (couponData.type == 2 && userDetails && userDetails.id)) && (
          <CouponModal shouldShow={showCouponModal} onClose={onCouponModalClose} image={couponData.image} />
        )}
    </>
  );
}

export default Sidebar;
